import axios from 'axios'
import { BUSINESS_API_BASE_URL } from './endpoint'

/**
 * Submit anonymous feedback
 * @param {string} businessId - The business ID
 * @param {Object} feedbackData - The feedback data
 * @returns {Promise} API response
 */
export const submitFeedback = async (feedbackData) => {
  try {
    console.log('Submitting feedback:', feedbackData)
    const response = await axios.post(`${BUSINESS_API_BASE_URL}/feedback/`, feedbackData)
    return response.data
  } catch (error) {
    console.error('Error submitting feedback:', error)
    throw error
  }
}
